import { Box, CircularProgress } from '@mui/material';
import { Suspense, useMemo } from 'react';
import { useGetEnergyDataQuery } from '@/api/energy-analysis/energyDataApiSlice';
import { DateTime } from 'luxon';
import EnergyGroupManagementDrawer from '@/features/service-management/components/energyxplorer/EnergyGroupManagementDrawer';

const EnergyGroupDrawerContainer = ({ isOpen, onClose, energyGroup }) => {
  const queryArgs = useMemo(() => {
    return {
      accountId: energyGroup?.accountId,
      energyGroupId: energyGroup?.energyGroupId,
      start: DateTime.now().minus({ days: 2 }).toMillis(),
      end: DateTime.now().minus({ days: 1 }).toMillis(),
    };
  }, [energyGroup?.accountId, energyGroup?.energyGroupId]);

  const { data: energyData } = useGetEnergyDataQuery(
    queryArgs,
    {
      refetchOnMountOrArgChange: true, // 👈 critical
    },
    {
      skip: !isOpen || !queryArgs?.energyGroupId || !queryArgs?.accountId,
    },
  );

  return (
    <Suspense
      fallback={
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            verticalAlign: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      }
    >
      <EnergyGroupManagementDrawer
        energyGroup={energyData}
        open={isOpen}
        onClose={onClose}
      />
    </Suspense>
  );
};

export default EnergyGroupDrawerContainer;
